import React, { useEffect } from 'react'
import BaseModal from './BaseModal'
import { Container, Modal } from 'react-bootstrap'
import rock from 'assets/images/eventBoatRacing/imgRocks.png'
import wave from 'assets/images/eventBoatRacing/imgWave.png'
import sadFace from 'assets/images/event-sad-face.svg'
import { t } from 'i18next'

function PenaltyPopupModal({ show, onHide, type, ...otherProps }) {

  useEffect(() => {
    let timeoutId;
    if (show) {
      timeoutId = setTimeout(() => {
        onHide()
      }, 3000)
    }

    return () => {
      clearTimeout(timeoutId)
    }
  }, [show])

	return (
		<BaseModal show={show} onHide={onHide} penalty {...otherProps}>
			<Modal.Body className="py-0">
				{type === 'rock' ? (
					<div className="d-flex justify-content-center">
						<img
							src={rock}
							alt="Rock Penalty"
							width={459}
              
							className="penalty-img"
						/>
					</div>
				) : type === 'wave' ? (
					<div className="d-flex justify-content-center">
						<img
							src={wave}
							alt="Wave Penalty"
							width={328}
							className="penalty-img wave"
						/>
					</div>
				) : null}

				<div className="popup-content d-flex justify-content-center align-items-center mt-2">
					<img src={sadFace} alt="Sad face" width={48} />
					<p className="text-center popup-content-text text-penalty">
						{type === 'rock'
							? t('event.boat_racing.popup.penalty.rock')
							: type === 'wave'
								? t('event.boat_racing.popup.penalty.wave')
								: null}
					</p>
				</div>
			</Modal.Body>
		</BaseModal>
	)
}

export default PenaltyPopupModal
